/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import * as stores from "stores";
import { isValidPageIndex } from "selectors/pageSelectors";

export const roundOffTo2Decimal = val => Math.round(val * 100) / 100;
export const isValidPageNum = pageNumber => Number.isInteger(pageNumber) && isValidPageIndex(stores, pageNumber - 1);
